function init() {
    var readMore = $('.director-bio-read-more');
    if(readMore.length > 0) {
        var readMoreLink = $('.director-bio-read-more-link');
        var readMorePostImage = $('.director-bio-read-more-post-image .post-image');
        var openClassName = 'open';
        var isOpen = false;

        function setDefaultHeight() {
            $(readMore).css('height', readMorePostImage.outerHeight() - $('.director-bio-info p').outerHeight(true) - $(readMoreLink).outerHeight(true));
            $(readMore).addClass('bottom-shadow');
        }

        $(window).on('resize', function(){
            if($(readMore).outerHeight() > readMorePostImage.outerHeight()) {
                setDefaultHeight();
                readMoreLink.css('display', 'inline');
            } else {
                $(readMore).removeClass('bottom-shadow');
                readMoreLink.css('display', 'none');
            }
        });

        if($(readMore).outerHeight() > readMorePostImage.outerHeight()) {
            setDefaultHeight();
            readMoreLink.css('display', 'inline');
        }

        $(readMoreLink).on('click', function(e) {
            e.preventDefault();
            $(readMore).toggleClass(openClassName);
            $(readMoreLink).text($(readMore).hasClass(openClassName) ? 'Read Less' : 'Read More');
            isOpen = !isOpen;

            if($(readMore).hasClass(openClassName)) {
                $(readMore).css('height', '100%');
            }
            else {
                setDefaultHeight();
            }
        })
    }
}

module.exports = {
    init: init
};